import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const BASE_URL      = "https://senutour.com/api";
const CLOUD_NAME    = "dhs2cu6vv";
const UPLOAD_PRESET = "senutour_unsigned";

const getToken = () => localStorage.getItem("token");
const getUser  = () => JSON.parse(localStorage.getItem("user") || "{}");

// ── Icônes SVG ──────────────────────────────────────────────────
const IcGrid    = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
const IcMap     = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg>;
const IcCalendar= () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IcHistory = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IcStar    = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const IcUpload  = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>;
const IcCheck   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IcX       = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcPhone   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.82 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.09 4.18 2 2 0 0 1 5.09 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IcEdit    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IcUser    = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;

const LANGUES_LISTE     = ["Français", "Anglais", "Wolof", "Arabe", "Espagnol", "Portugais", "Allemand", "Italien"];
const SPECIALITES_LISTE = ["Histoire & Culture", "Nature & Écologie", "Gastronomie", "Architecture", "Artisanat", "Sports & Aventure", "Musique & Arts", "Plages & Côtes", "Villes & Urbanisme", "Vie nocturne"];
const VILLES            = ["Dakar", "Diamniadio", "Saly", "Saint-Louis", "Ziguinchor", "Thiès", "Touba", "Kaolack"];

const STATUT_RESA = {
  confirmee:  { label: "Confirmée",  color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
  en_attente: { label: "En attente", color: "#C4841A", bg: "rgba(196,132,26,0.10)" },
  annulee:    { label: "Annulée",    color: "#C4441A", bg: "rgba(196,68,26,0.10)" },
};

const ONGLETS = [
  { id: "dashboard",    label: "Vue générale",    Icon: IcGrid },
  { id: "profil",       label: "Mon profil",      Icon: IcMap },
  { id: "reservations", label: "Réservations",    Icon: IcCalendar },
  { id: "historique",   label: "Historique",      Icon: IcHistory },
  { id: "avis",         label: "Avis clients",    Icon: IcStar },
];

const PROFIL_VIDE = {
  nom: "", prenom: "", description: "", ville: "Dakar",
  telephone: "", whatsapp: "", prixJournee: "", prixDemiJournee: "",
  experience: "", langues: [], specialites: [], disponible: true,
};

const formatPrix = (p) => p ? Number(p).toLocaleString("fr-FR") + " F" : "—";

export default function GuideDashboard() {
  const navigate  = useNavigate();
  const user      = getUser();
  const fileRef   = useRef();

  const [onglet, setOnglet]           = useState("dashboard");
  const [guide, setGuide]             = useState(null);
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading]         = useState(true);
  const [filtreStatut, setFiltreStatut] = useState("tous");

  // ── Formulaire profil ────────────────────────────────────────
  const [showForm, setShowForm]       = useState(false);
  const [form, setForm]               = useState(PROFIL_VIDE);
  const [photos, setPhotos]           = useState([]);
  const [uploading, setUploading]     = useState(false);
  const [saving, setSaving]           = useState(false);

  // ── Chargement ───────────────────────────────────────────────
  useEffect(() => {
    const charger = async () => {
      try {
        const [resG, resR] = await Promise.all([
          fetch(`${BASE_URL}/guides/mon-profil`, { headers: { Authorization: `Bearer ${getToken()}` } }),
          fetch(`${BASE_URL}/reservations-guide/guide`, { headers: { Authorization: `Bearer ${getToken()}` } }),
        ]);
        const g = await resG.json();
        const r = await resR.json();
        if (g && g.id) {
          setGuide(g);
          setForm({
            nom: g.nom || "", prenom: g.prenom || "", description: g.description || "",
            ville: g.ville || "Dakar", telephone: g.telephone || "", whatsapp: g.whatsapp || "",
            prixJournee: g.prixJournee || "", prixDemiJournee: g.prixDemiJournee || "",
            experience: g.experience || "", langues: g.langues || [], specialites: g.specialites || [],
            disponible: g.disponible ?? true,
          });
          setPhotos(g.images || []);
        }
        setReservations(Array.isArray(r) ? r : []);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    charger();
  }, []);

  // ── Upload photos ────────────────────────────────────────────
  const handlePhotos = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    try {
      const urls = await Promise.all(files.map(async (file) => {
        const fd = new FormData();
        fd.append("file", file);
        fd.append("upload_preset", UPLOAD_PRESET);
        const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, { method: "POST", body: fd });
        const data = await res.json();
        return data.secure_url;
      }));
      setPhotos(prev => [...prev, ...urls]);
    } catch { alert("Erreur upload photo."); }
    finally { setUploading(false); }
  };

  const toggleLangue      = (l) => setForm(prev => ({ ...prev, langues:     prev.langues.includes(l)     ? prev.langues.filter(x => x !== l)     : [...prev.langues, l] }));
  const toggleSpecialite  = (s) => setForm(prev => ({ ...prev, specialites: prev.specialites.includes(s) ? prev.specialites.filter(x => x !== s) : [...prev.specialites, s] }));

  // ── Sauvegarder profil ───────────────────────────────────────
  const sauvegarderProfil = async () => {
    if (!form.nom || !form.ville) { alert("Nom et ville obligatoires."); return; }
    setSaving(true);
    try {
      const payload = {
        ...form,
        prixJournee:     parseInt(form.prixJournee)     || 0,
        prixDemiJournee: parseInt(form.prixDemiJournee) || 0,
        experience:      parseInt(form.experience)      || 0,
        images: photos,
      };
      let res;
      if (guide) {
        // Mise à jour
        res = await fetch(`${BASE_URL}/guides/${guide.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
          body: JSON.stringify(payload),
        });
      } else {
        // Création
        res = await fetch(`${BASE_URL}/guides`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
          body: JSON.stringify(payload),
        });
      }
      const data = await res.json();
      if (res.ok) {
        setGuide(data.guide || data);
        setShowForm(false);
        alert(guide ? "Profil mis à jour !" : "Profil créé !");
      } else { alert(data.message || "Erreur."); }
    } catch { alert("Erreur serveur."); }
    finally { setSaving(false); }
  };

  // ── Actions réservations ─────────────────────────────────────
  const confirmerResa = async (id) => {
    await fetch(`${BASE_URL}/reservations-guide/${id}/confirmer`, { method: "PATCH", headers: { Authorization: `Bearer ${getToken()}` } });
    setReservations(prev => prev.map(r => r.id === id ? { ...r, statut: "confirmee" } : r));
  };

  const annulerResa = async (id) => {
    await fetch(`${BASE_URL}/reservations-guide/${id}/annuler`, { method: "PATCH", headers: { Authorization: `Bearer ${getToken()}` } });
    setReservations(prev => prev.map(r => r.id === id ? { ...r, statut: "annulee" } : r));
  };

  // ── Dérivés ──────────────────────────────────────────────────
  const resasAttente  = reservations.filter(r => r.statut === "en_attente");
  const resasFiltrees = filtreStatut === "tous" ? reservations : reservations.filter(r => r.statut === filtreStatut);
  const totalRevenus  = reservations.filter(r => r.statut === "confirmee").reduce((s, r) => s + (r.total || 0), 0);

  const labelStyle = { display: "block", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 };
  const inputStyle = { width: "100%", boxSizing: "border-box", padding: "11px 14px", border: "1.5px solid #E8DCC8", borderRadius: 10, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, outline: "none", color: "#1C1008", background: "white" };

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FAF5EC", fontFamily: "'Space Grotesk',sans-serif", color: "#7A5A3A" }}>
      Chargement…
    </div>
  );

  return (
    <>
      <Navbar />
      <div style={{ fontFamily: "'Space Grotesk',sans-serif", background: "#FAF5EC", minHeight: "100vh", color: "#1C1008" }}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
          .onglet-btn { transition: all .2s; cursor: pointer; border: none; background: none; }
          .onglet-btn:hover { color: #C4441A !important; }
          .btn-primary { background: #C4441A; transition: background .2s; border: none; cursor: pointer; }
          .btn-primary:hover { background: #A03614; }
          .btn-success { background: #3D6B2E; transition: background .2s; border: none; cursor: pointer; }
          .btn-success:hover { background: #2D5220; }
          .card-hover { transition: all .2s; }
          .card-hover:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(28,16,8,0.10) !important; }
          .pill { cursor: pointer; transition: all .15s; user-select: none; }
          .photo-zone { border: 2px dashed #E8DCC8; border-radius: 12px; padding: 32px; text-align: center; cursor: pointer; transition: border-color .2s; }
          .photo-zone:hover { border-color: #C4441A; }
          @media (max-width: 767px) { .stats-grid { grid-template-columns: 1fr 1fr !important; } }
        `}</style>

        {/* ── HEADER ── */}
        <div style={{ background: "linear-gradient(135deg,#1C1008 0%,#2D1A08 100%)", padding: "48px 5% 36px", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle,rgba(196,68,26,.07) 1px,transparent 1px)", backgroundSize: "28px 28px" }} />
          <div style={{ maxWidth: 1100, margin: "0 auto", position: "relative", zIndex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
                <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg,#C4441A,#E8834A)", display: "flex", alignItems: "center", justifyContent: "center", border: "3px solid rgba(255,255,255,0.2)", flexShrink: 0, overflow: "hidden" }}>
                  {(guide?.images?.[0] || localStorage.getItem("sunutour_photo"))
                    ? <img src={guide?.images?.[0] || localStorage.getItem("sunutour_photo")} style={{ width: "100%", height: "100%", objectFit: "cover" }} alt="profil" />
                    : <IcUser />}
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#C4441A", textTransform: "uppercase", letterSpacing: 2, marginBottom: 4 }}>Dashboard Guide Touristique · JOJ 2026</div>
                  <h1 style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "white", margin: 0 }}>
                    {guide ? `${guide.prenom || ""} ${guide.nom}`.trim() : `${user.prenom || ""} ${user.nom || ""}`.trim() || "Mon profil"}
                  </h1>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginTop: 3 }}>
                    {guide ? `${guide.ville} · ${Array.isArray(guide.langues) ? guide.langues.join(", ") : guide.langues || ""}` : "Complétez votre profil pour être visible"}
                  </div>
                </div>
              </div>
              <button className="btn-primary" onClick={() => { setOnglet("profil"); setShowForm(true); }}
                style={{ color: "white", borderRadius: 10, padding: "12px 22px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, display: "flex", alignItems: "center", gap: 8, boxShadow: "0 8px 20px rgba(196,68,26,0.35)" }}>
                <IcEdit /> {guide ? "Modifier mon profil" : "Créer mon profil"}
              </button>
            </div>
          </div>
        </div>

        {/* ── ONGLETS ── */}
        <div style={{ background: "white", borderBottom: "1.5px solid #E8DCC8", padding: "0 5%", overflowX: "auto" }}>
          <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", gap: 4, minWidth: "max-content" }}>
            {ONGLETS.map(o => (
              <button key={o.id} className="onglet-btn" onClick={() => setOnglet(o.id)}
                style={{ padding: "16px 18px", fontSize: 13, fontWeight: 600, color: onglet === o.id ? "#C4441A" : "#7A5A3A", borderBottom: onglet === o.id ? "2px solid #C4441A" : "2px solid transparent", marginBottom: -1, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
                <o.Icon /> {o.label}
                {o.id === "reservations" && resasAttente.length > 0 && (
                  <span style={{ background: "#C4441A", color: "white", borderRadius: "50%", width: 18, height: 18, fontSize: 10, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{resasAttente.length}</span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "36px 5% 60px" }}>

          {/* ══ VUE GÉNÉRALE ══ */}
          {onglet === "dashboard" && (
            <>
              {!guide && (
                <div style={{ background: "rgba(196,132,26,0.06)", border: "1.5px solid rgba(196,132,26,0.25)", borderRadius: 12, padding: "20px 24px", marginBottom: 28, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "#C4841A", marginBottom: 4 }}>Profil incomplet</div>
                    <div style={{ fontSize: 13, color: "#7A5A3A" }}>Créez votre profil guide pour apparaître dans les recherches et recevoir des réservations.</div>
                  </div>
                  <button className="btn-primary" onClick={() => { setOnglet("profil"); setShowForm(true); }}
                    style={{ color: "white", borderRadius: 8, padding: "10px 20px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, whiteSpace: "nowrap" }}>
                    Créer mon profil →
                  </button>
                </div>
              )}

              <div className="stats-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16, marginBottom: 32 }}>
                {[
                  { label: "Réservations totales", value: reservations.length,             color: "#C4441A" },
                  { label: "En attente",            value: resasAttente.length,             color: "#C4841A" },
                  { label: "Revenus confirmés",     value: totalRevenus.toLocaleString(),   color: "#3D6B2E", suffix: " F" },
                  { label: "Note",                  value: guide?.note?.toFixed(1) || "—", color: "#C4441A", suffix: guide ? "/5" : "" },
                ].map((s, i) => (
                  <div key={i} className="card-hover" style={{ background: "white", borderRadius: 14, padding: "22px", border: "1.5px solid #E8DCC8", boxShadow: "0 2px 12px rgba(28,16,8,0.06)" }}>
                    <div style={{ fontFamily: "'Fraunces',serif", fontSize: 28, fontWeight: 800, color: s.color }}>{s.value}<span style={{ fontSize: 13, fontWeight: 600 }}>{s.suffix || ""}</span></div>
                    <div style={{ fontSize: 12, color: "#7A5A3A", marginTop: 6, fontWeight: 600 }}>{s.label}</div>
                  </div>
                ))}
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
                {/* Profil rapide */}
                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mon profil guide</h3>
                    <button onClick={() => { setOnglet("profil"); setShowForm(true); }} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>
                      {guide ? "Modifier →" : "Créer →"}
                    </button>
                  </div>
                  {!guide
                    ? <div style={{ padding: 32, textAlign: "center", color: "#7A5A3A", fontSize: 13 }}>Aucun profil — créez le vôtre pour être visible !</div>
                    : (
                      <div style={{ padding: "20px 24px" }}>
                        <div style={{ display: "flex", gap: 16, marginBottom: 14 }}>
                          <div style={{ width: 56, height: 56, borderRadius: 10, overflow: "hidden", flexShrink: 0, background: "#F2E4C8" }}>
                            {guide.images?.[0]
                              ? <img src={guide.images[0]} alt={guide.nom} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                              : <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>🧭</div>}
                          </div>
                          <div>
                            <div style={{ fontSize: 15, fontWeight: 700, color: "#1C1008" }}>{guide.prenom} {guide.nom}</div>
                            <div style={{ fontSize: 12, color: "#7A5A3A" }}>{guide.ville} · {guide.experience ? `${guide.experience} ans d'expérience` : ""}</div>
                            <div style={{ marginTop: 4, display: "flex", gap: 4, flexWrap: "wrap" }}>
                              {(Array.isArray(guide.langues) ? guide.langues : []).map(l => (
                                <span key={l} style={{ fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20, background: "rgba(196,68,26,0.08)", color: "#C4441A" }}>{l}</span>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex", gap: 12 }}>
                          <div style={{ flex: 1, background: "#FAF5EC", borderRadius: 10, padding: "12px", textAlign: "center" }}>
                            <div style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#C4441A" }}>{formatPrix(guide.prixJournee)}</div>
                            <div style={{ fontSize: 11, color: "#7A5A3A" }}>journée</div>
                          </div>
                          <div style={{ flex: 1, background: "#FAF5EC", borderRadius: 10, padding: "12px", textAlign: "center" }}>
                            <div style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#3D6B2E" }}>{formatPrix(guide.prixDemiJournee)}</div>
                            <div style={{ fontSize: 11, color: "#7A5A3A" }}>demi-journée</div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                </div>

                {/* Réservations récentes */}
                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Réservations récentes</h3>
                    <button onClick={() => setOnglet("reservations")} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                  </div>
                  {reservations.length === 0
                    ? <div style={{ padding: 32, textAlign: "center", color: "#7A5A3A", fontSize: 13 }}>Aucune réservation pour le moment</div>
                    : reservations.slice(0, 4).map((r, i, arr) => (
                      <div key={r.id} style={{ padding: "13px 24px", borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 3 }}>
                          <span style={{ fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.nomClient} {r.prenomClient}</span>
                          <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 8px", borderRadius: 20, background: STATUT_RESA[r.statut]?.bg, color: STATUT_RESA[r.statut]?.color }}>{STATUT_RESA[r.statut]?.label}</span>
                        </div>
                        <div style={{ fontSize: 11, color: "#7A5A3A" }}>{r.dateVisite} · {r.nbPersonnes} pers. · {r.typePrestation === "journee" ? "Journée" : "Demi-journée"}</div>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#C4441A", marginTop: 3 }}>{formatPrix(r.total)}</div>
                      </div>
                    ))
                  }
                </div>
              </div>

              {resasAttente.length > 0 && (
                <div style={{ marginTop: 20, background: "rgba(196,132,26,0.06)", border: "1.5px solid rgba(196,132,26,0.25)", borderRadius: 12, padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "#C4841A" }}>{resasAttente.length} réservation{resasAttente.length > 1 ? "s" : ""} en attente de confirmation</div>
                    <div style={{ fontSize: 12, color: "#7A5A3A" }}>Des touristes attendent votre réponse.</div>
                  </div>
                  <button onClick={() => setOnglet("reservations")} className="btn-primary"
                    style={{ color: "white", borderRadius: 8, padding: "9px 18px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, whiteSpace: "nowrap" }}>
                    Voir →
                  </button>
                </div>
              )}
            </>
          )}

          {/* ══ MON PROFIL ══ */}
          {onglet === "profil" && (
            <>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
                <div>
                  <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mon profil guide</h2>
                  <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{guide ? "Visible sur la plateforme SenuTour" : "Profil non encore créé"}</p>
                </div>
                <button className="btn-primary" onClick={() => setShowForm(!showForm)}
                  style={{ color: "white", borderRadius: 10, padding: "10px 20px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                  {showForm ? "Annuler" : guide ? "Modifier" : "+ Créer mon profil"}
                </button>
              </div>

              {/* Formulaire */}
              {showForm && (
                <div style={{ background: "white", borderRadius: 16, border: "1.5px solid #E8DCC8", padding: "32px", marginBottom: 28, boxShadow: "0 4px 20px rgba(28,16,8,0.08)" }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 800, color: "#1C1008", marginBottom: 24 }}>
                    {guide ? "Modifier mon profil" : "Créer mon profil guide"}
                  </h3>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 20px" }}>
                    {[
                      { label: "Prénom", key: "prenom", placeholder: "Ex: Abdoulaye" },
                      { label: "Nom *",  key: "nom",    placeholder: "Ex: Niang" },
                    ].map(f => (
                      <div key={f.key} style={{ marginBottom: 16 }}>
                        <label style={labelStyle}>{f.label}</label>
                        <input value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })} placeholder={f.placeholder} style={inputStyle} />
                      </div>
                    ))}
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 16px" }}>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Ville *</label>
                      <select value={form.ville} onChange={e => setForm({ ...form, ville: e.target.value })} style={inputStyle}>
                        {VILLES.map(v => <option key={v}>{v}</option>)}
                      </select>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Expérience (années)</label>
                      <input type="number" value={form.experience} onChange={e => setForm({ ...form, experience: e.target.value })} placeholder="Ex: 5" style={inputStyle} />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Disponible</label>
                      <select value={form.disponible ? "oui" : "non"} onChange={e => setForm({ ...form, disponible: e.target.value === "oui" })} style={inputStyle}>
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 16px" }}>
                    {[
                      { label: "Téléphone",   key: "telephone",       placeholder: "+221 77 000 00 00", type: "tel" },
                      { label: "WhatsApp",    key: "whatsapp",        placeholder: "+221 77 000 00 00", type: "tel" },
                      { label: "Prix journée (F CFA)",      key: "prixJournee",     placeholder: "Ex: 50000", type: "number" },
                      { label: "Prix demi-journée (F CFA)", key: "prixDemiJournee", placeholder: "Ex: 30000", type: "number" },
                    ].map(f => (
                      <div key={f.key} style={{ marginBottom: 16 }}>
                        <label style={labelStyle}>{f.label}</label>
                        <input type={f.type} value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })} placeholder={f.placeholder} style={inputStyle} />
                      </div>
                    ))}
                  </div>

                  <div style={{ marginBottom: 20 }}>
                    <label style={labelStyle}>Description</label>
                    <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
                      placeholder="Décrivez votre expérience, vos parcours préférés, votre passion pour le Sénégal…"
                      rows={4} style={{ ...inputStyle, resize: "vertical", lineHeight: 1.6 }} />
                  </div>

                  <div style={{ marginBottom: 20 }}>
                    <label style={labelStyle}>Langues parlées</label>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {LANGUES_LISTE.map(l => (
                        <span key={l} className="pill" onClick={() => toggleLangue(l)}
                          style={{ padding: "6px 14px", borderRadius: 20, fontSize: 13, fontWeight: 500, border: `1.5px solid ${form.langues.includes(l) ? "#C4441A" : "#E8DCC8"}`, background: form.langues.includes(l) ? "rgba(196,68,26,0.08)" : "white", color: form.langues.includes(l) ? "#C4441A" : "#7A5A3A" }}>
                          {form.langues.includes(l) ? "✓ " : ""}{l}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div style={{ marginBottom: 20 }}>
                    <label style={labelStyle}>Spécialités</label>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {SPECIALITES_LISTE.map(s => (
                        <span key={s} className="pill" onClick={() => toggleSpecialite(s)}
                          style={{ padding: "6px 14px", borderRadius: 20, fontSize: 13, fontWeight: 500, border: `1.5px solid ${form.specialites.includes(s) ? "#3D6B2E" : "#E8DCC8"}`, background: form.specialites.includes(s) ? "rgba(61,107,46,0.08)" : "white", color: form.specialites.includes(s) ? "#3D6B2E" : "#7A5A3A" }}>
                          {form.specialites.includes(s) ? "✓ " : ""}{s}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div style={{ marginBottom: 24 }}>
                    <label style={labelStyle}>Photos</label>
                    <div className="photo-zone" onClick={() => fileRef.current?.click()}>
                      <input ref={fileRef} type="file" multiple accept="image/*" onChange={handlePhotos} style={{ display: "none" }} />
                      {uploading
                        ? <p style={{ color: "#7A5A3A", margin: 0, fontSize: 14 }}>Chargement…</p>
                        : <><IcUpload /><p style={{ color: "#7A5A3A", margin: "8px 0 4px", fontSize: 14, fontWeight: 600 }}>Cliquez pour ajouter des photos</p><p style={{ color: "#B8A898", margin: 0, fontSize: 12 }}>Photo de profil, lieux de visite…</p></>
                      }
                    </div>
                    {photos.length > 0 && (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 12 }}>
                        {photos.map((url, i) => (
                          <div key={i} style={{ position: "relative", width: 80, height: 80, borderRadius: 8, overflow: "hidden" }}>
                            <img src={url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            <button onClick={() => setPhotos(prev => prev.filter(p => p !== url))}
                              style={{ position: "absolute", top: 4, right: 4, background: "rgba(196,68,26,0.85)", border: "none", borderRadius: "50%", width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "white" }}>
                              <IcX />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                    <button onClick={() => setShowForm(false)}
                      style={{ background: "white", border: "1.5px solid #E8DCC8", borderRadius: 10, padding: "11px 20px", fontSize: 14, fontWeight: 600, color: "#7A5A3A", cursor: "pointer" }}>
                      Annuler
                    </button>
                    <button className="btn-primary" onClick={sauvegarderProfil} disabled={saving}
                      style={{ color: "white", borderRadius: 10, padding: "11px 28px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, opacity: saving ? 0.7 : 1 }}>
                      {saving ? "Enregistrement…" : "Enregistrer"}
                    </button>
                  </div>
                </div>
              )}

              {/* Aperçu profil */}
              {guide && !showForm && (
                <div style={{ background: "white", borderRadius: 16, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ height: 160, background: "linear-gradient(135deg,#1C1008,#2D1A08)", overflow: "hidden", position: "relative" }}>
                    {guide.images?.[0] && <img src={guide.images[0]} alt={guide.nom} style={{ width: "100%", height: "100%", objectFit: "cover", opacity: 0.6 }} />}
                    <div style={{ position: "absolute", bottom: 16, left: 24, right: 24, display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}>
                      <div>
                        <div style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "white" }}>{guide.prenom} {guide.nom}</div>
                        <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)" }}>{guide.ville} · {guide.experience} ans d'expérience</div>
                      </div>
                      <span style={{ fontSize: 12, fontWeight: 700, padding: "5px 14px", borderRadius: 20, background: guide.disponible ? "rgba(61,107,46,0.85)" : "rgba(196,68,26,0.85)", color: "white" }}>
                        {guide.disponible ? "Disponible" : "Indisponible"}
                      </span>
                    </div>
                  </div>
                  <div style={{ padding: "24px 28px" }}>
                    {guide.description && <p style={{ fontSize: 14, color: "#7A5A3A", lineHeight: 1.7, marginBottom: 20 }}>{guide.description}</p>}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
                      <div>
                        <div style={{ fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>Langues</div>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                          {(Array.isArray(guide.langues) ? guide.langues : []).map(l => (
                            <span key={l} style={{ fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 20, background: "rgba(196,68,26,0.08)", color: "#C4441A" }}>{l}</span>
                          ))}
                        </div>
                      </div>
                      <div>
                        <div style={{ fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>Spécialités</div>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                          {(Array.isArray(guide.specialites) ? guide.specialites : []).map(s => (
                            <span key={s} style={{ fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 20, background: "rgba(61,107,46,0.08)", color: "#3D6B2E" }}>{s}</span>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 12, paddingTop: 20, borderTop: "1px solid #F2E4C8" }}>
                      <div style={{ flex: 1, background: "#FAF5EC", borderRadius: 10, padding: "14px", textAlign: "center" }}>
                        <div style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 800, color: "#C4441A" }}>{formatPrix(guide.prixJournee)}</div>
                        <div style={{ fontSize: 11, color: "#7A5A3A", marginTop: 2 }}>journée complète</div>
                      </div>
                      <div style={{ flex: 1, background: "#FAF5EC", borderRadius: 10, padding: "14px", textAlign: "center" }}>
                        <div style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 800, color: "#3D6B2E" }}>{formatPrix(guide.prixDemiJournee)}</div>
                        <div style={{ fontSize: 11, color: "#7A5A3A", marginTop: 2 }}>demi-journée</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {!guide && !showForm && (
                <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A" }}>
                  <p style={{ fontSize: 15, marginBottom: 16 }}>Vous n'avez pas encore de profil guide.</p>
                  <button className="btn-primary" onClick={() => setShowForm(true)} style={{ color: "white", borderRadius: 10, padding: "12px 24px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                    + Créer mon profil
                  </button>
                </div>
              )}
            </>
          )}

          {/* ══ RÉSERVATIONS ══ */}
          {onglet === "reservations" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Réservations</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>
                  {reservations.length} réservation{reservations.length !== 1 ? "s" : ""}
                  {resasAttente.length > 0 && <span style={{ color: "#C4841A", fontWeight: 700 }}> · {resasAttente.length} en attente</span>}
                </p>
              </div>

              <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
                {["tous", "en_attente", "confirmee", "annulee"].map(s => (
                  <button key={s} onClick={() => setFiltreStatut(s)}
                    style={{ padding: "7px 16px", borderRadius: 20, border: `1.5px solid ${filtreStatut === s ? "#C4441A" : "#E8DCC8"}`, background: filtreStatut === s ? "#C4441A" : "white", color: filtreStatut === s ? "white" : "#7A5A3A", fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "all .2s" }}>
                    {s === "tous" ? "Toutes" : STATUT_RESA[s]?.label}
                  </button>
                ))}
              </div>

              {resasFiltrees.length === 0
                ? <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A", fontSize: 14 }}>Aucune réservation</div>
                : (
                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    {resasFiltrees.map(r => (
                      <div key={r.id} style={{ background: "white", borderRadius: 14, border: `1.5px solid ${r.statut === "en_attente" ? "rgba(196,132,26,0.35)" : "#E8DCC8"}`, padding: "20px 24px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
                              <span style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008" }}>{r.nomClient} {r.prenomClient}</span>
                              <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: STATUT_RESA[r.statut]?.bg, color: STATUT_RESA[r.statut]?.color }}>{STATUT_RESA[r.statut]?.label}</span>
                              <span style={{ fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20, background: "rgba(196,68,26,0.08)", color: "#C4441A" }}>
                                {r.typePrestation === "journee" ? "Journée complète" : "Demi-journée"}
                              </span>
                            </div>
                            <div style={{ fontSize: 13, color: "#7A5A3A", marginBottom: 4 }}>📅 {r.dateVisite} · 👥 {r.nbPersonnes} personne{r.nbPersonnes > 1 ? "s" : ""}</div>
                            <div style={{ display: "flex", gap: 16, fontSize: 12, color: "#7A5A3A" }}>
                              <span style={{ display: "flex", alignItems: "center", gap: 4 }}><IcPhone /> {r.telephoneClient}</span>
                              <span>✉️ {r.emailClient}</span>
                            </div>
                            {r.message && <div style={{ marginTop: 8, fontSize: 12, color: "#7A5A3A", background: "#FAF5EC", borderRadius: 8, padding: "8px 12px" }}>💬 {r.message}</div>}
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <div style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "#C4441A" }}>{formatPrix(r.total)}</div>
                            <div style={{ fontSize: 11, color: "#7A5A3A", marginBottom: 8 }}>{r.modePaiement}</div>
                            {r.statut === "en_attente" && (
                              <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                <button className="btn-success" onClick={() => confirmerResa(r.id)}
                                  style={{ color: "white", borderRadius: 8, padding: "8px 14px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
                                  <IcCheck /> Confirmer
                                </button>
                                <button className="btn-primary" onClick={() => annulerResa(r.id)}
                                  style={{ color: "white", borderRadius: 8, padding: "8px 14px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
                                  <IcX /> Refuser
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
            </>
          )}

          {/* ══ HISTORIQUE ══ */}
          {onglet === "historique" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Historique & Revenus</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{reservations.filter(r => r.statut === "confirmee").length} réservation{reservations.filter(r => r.statut === "confirmee").length !== 1 ? "s" : ""} confirmée{reservations.filter(r => r.statut === "confirmee").length !== 1 ? "s" : ""}</p>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16, marginBottom: 24 }}>
                {[
                  { label: "Revenus confirmés", value: totalRevenus.toLocaleString(), suffix: " F", color: "#3D6B2E" },
                  { label: "Visites confirmées", value: reservations.filter(r => r.statut === "confirmee").length, suffix: "", color: "#C4441A" },
                  { label: "Visites annulées",   value: reservations.filter(r => r.statut === "annulee").length, suffix: "", color: "#7A5A3A" },
                ].map((s, i) => (
                  <div key={i} style={{ background: "white", borderRadius: 14, padding: "22px", border: "1.5px solid #E8DCC8", textAlign: "center" }}>
                    <div style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: s.color }}>{s.value}<span style={{ fontSize: 13 }}>{s.suffix}</span></div>
                    <div style={{ fontSize: 12, color: "#7A5A3A", marginTop: 4, fontWeight: 600 }}>{s.label}</div>
                  </div>
                ))}
              </div>

              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                {reservations.length === 0
                  ? <div style={{ padding: 40, textAlign: "center", color: "#7A5A3A", fontSize: 14 }}>Aucune réservation pour le moment</div>
                  : (
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr style={{ background: "#FAF5EC" }}>
                          {["Client", "Date visite", "Personnes", "Type", "Total", "Statut"].map(h => (
                            <th key={h} style={{ padding: "12px 20px", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1.5px solid #E8DCC8" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {reservations.map((r, i) => (
                          <tr key={r.id} style={{ borderBottom: i < reservations.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                            <td style={{ padding: "14px 20px", fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.nomClient} {r.prenomClient}</td>
                            <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{r.dateVisite}</td>
                            <td style={{ padding: "14px 20px", fontSize: 13, color: "#7A5A3A" }}>{r.nbPersonnes} pers.</td>
                            <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{r.typePrestation === "journee" ? "Journée" : "Demi-journée"}</td>
                            <td style={{ padding: "14px 20px", fontFamily: "'Fraunces',serif", fontSize: 15, fontWeight: 700, color: "#3D6B2E" }}>{formatPrix(r.total)}</td>
                            <td style={{ padding: "14px 20px" }}>
                              <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: STATUT_RESA[r.statut]?.bg, color: STATUT_RESA[r.statut]?.color }}>
                                {STATUT_RESA[r.statut]?.label}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )
                }
              </div>
            </>
          )}

          {/* ══ AVIS ══ */}
          {onglet === "avis" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Avis clients</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>Note moyenne : <strong>{guide?.note?.toFixed(1) || "—"}/5</strong> · {guide?.avis || 0} avis</p>
              </div>
              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", padding: "32px", textAlign: "center" }}>
                <div style={{ fontFamily: "'Fraunces',serif", fontSize: 56, fontWeight: 800, color: "#C4441A", lineHeight: 1 }}>{guide?.note?.toFixed(1) || "—"}</div>
                <div style={{ margin: "12px 0 8px" }}>
                  {[1,2,3,4,5].map(i => (
                    <span key={i} style={{ color: i <= Math.round(guide?.note || 0) ? "#C4441A" : "#E8DCC8", fontSize: 24 }}>★</span>
                  ))}
                </div>
                <p style={{ fontSize: 13, color: "#7A5A3A", marginTop: 12 }}>
                  {guide ? "Les avis seront affichés ici dès que des clients en laisseront." : "Créez votre profil pour commencer à recevoir des avis."}
                </p>
              </div>
            </>
          )}

        </div>
      </div>
      <Footer />
    </>
  );
}